import { render, staticRenderFns } from "./EditBankTransferPaymentConfig.vue?vue&type=template&id=e25e23d4&"
import script from "./EditBankTransferPaymentConfig.vue?vue&type=script&lang=ts&"
export * from "./EditBankTransferPaymentConfig.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports